import { useEffect } from 'react'
import htmr from 'htmr'
import { useYotpoRatingScripts } from '@helpers/hooks'
import Translations from '@helpers/translations'
import SectionHeader from '@components/ui/SectionHeader'

type YotpoReviewsProps = {
  productId: string
  productTitle: string
  productImage: string
  byline?: string
}

function YotpoReviews({
  productId,
  productTitle,
  productImage,
  byline
}: YotpoReviewsProps) {
  const yotpoScriptsLoaded = useYotpoRatingScripts()

  useEffect(() => {
    if (
      yotpoScriptsLoaded &&
      typeof window.yotpo !== 'undefined' &&
      window.yotpo?.initialized
    ) {
      window.yotpo?.refreshWidgets()
    }
  }, [yotpoScriptsLoaded])

  return (
    <div id="yotpo-reviews">
      <SectionHeader title={Translations.localise('product.reviews.title')} />
      <div
        className="yotpo yotpo-main-widget"
        data-product-id={productId}
        data-name={productTitle}
        data-url=""
        data-image-url={productImage}
        data-description={htmr(byline || '')}
      />
    </div>
  )
}

export default YotpoReviews
